import React, { createContext, useReducer } from "react";
import { whereIsthisInitialState } from '../reducers';
import constant from '../constants/whereIsthisConstant';
import whereIsThisReducer from "../reducers/whereIsthisReducer";
import feedBackService from "../services/feedBackService";
import requestTool from "../tools/requestTool";

export const whereIsThisContext = createContext();

export const WhereIsThisContextProvider = (props) => {

    const [state, dispatch] = useReducer(whereIsThisReducer, whereIsthisInitialState);
    const setIsLoading = (data) => {
        dispatch(success(data));
        function success(data) { return { type: constant.SHOW_IS_LOADING, payload: data }; }
    };
    const changeCoordinate = (coordinate) => {
        dispatch(success(coordinate));
        function success(data) { return { type: constant.WHERE_IS_tHIS_CHANGE, payload: data }; }
    };
    const changeObjectType = (data) => {
        dispatch(success(data));
        function success(data) { return { type: constant.SELECTED_OBJECT_TYPE, payload: data }; }
    };
    const getUseFeedBack = (data) => {

        feedBackService.getUseFeedBack().then(x => {
            if (!x.success) {
                dispatch(success(false));
                return;
            }
            if (x.data == null) {
                dispatch(success(false));
                return;
            }
            dispatch(success(x.data.isUse));
        }).catch(x => {})

        function success(data) { return { type: constant.GET_USE_ISFEEDBACK, payload: data }; }
    };
    const setSelectedFeatures = (data) => {


        dispatch(success(data));

        function success(data) { return { type: constant.SET_SELECTED_FEATURES, payload: data }; }
    };
    const getSelectedFeatures = () => {

        return state.selectedFeatures;
    };
    const setAddressData = (data) => {

        dispatch(success(data));

        function success(data) { return { type: constant.SELECTED_ADDRESS_DATA, payload: data }; }
    };
    const reloadCustomerData = (data) => {

        dispatch(success(data));

        function success(data) { return { type: constant.RELOAD_CUSTOMER_TABLE, payload: data }; }
    };
    const reloadTreeData = (data) => {

        dispatch(success(data));

        function success(data) { return { type: constant.RELOAD_TREE_STRUCTURE, payload: data }; }
    };
    const exportAdministrativeAreawithWkt = async (wkt, fnc) => {

        try {
            requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicFileExport/ExportExcelFileFromWkt",
                {
                    wkt: wkt,
                    layerId: 0
                }).then(response => {

                    if (!response.success) {
                        if (fnc) {
                            fnc(response.message);
                        }
                        return;
                    }
                    const byteCharacters = atob(response.data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);

                    // Blob oluştur
                    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                    // Blob URL oluştur
                    const blobUrl = URL.createObjectURL(blob);

                    // Bağlantı oluştur
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = "İdari alan raporu";

                    // Bağlantıyı tıkla
                    link.click();

                    // Blob URL'yi serbest bırak
                    URL.revokeObjectURL(blobUrl);
                })
        } catch (e) {

        }

    };


    const freeSpaceAreaReport = async (data, fnc) => {

        try {
            requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/FreeSpace/GetFreeSpaceAreaReport",data).then(response => {

                if (!response.success) {
                    if (fnc) {
                        fnc(response.message);
                    }
                    return;
                }
                const byteCharacters = atob(response.data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                // Blob oluştur
                const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // Blob URL oluştur
                const blobUrl = URL.createObjectURL(blob);

                // Bağlantı oluştur
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = "Boşta kalan alan raporu";

                // Bağlantıyı tıkla
                link.click();

                // Blob URL'yi serbest bırak
                URL.revokeObjectURL(blobUrl);
                fnc();
            })
        } catch (e) {

        }
    }

    const demographicAreaReport = async (data, fnc) => {

        try {
            requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/Report/GetDemorgraphicAreaFromWkt", data).then(response => {

                if (!response.success) {
                    if (fnc) {
                        fnc(response.message);
                    }
                    return;
                }
                const byteCharacters = atob(response.data.base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                // Blob oluştur
                const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // Blob URL oluştur
                const blobUrl = URL.createObjectURL(blob);

                // Bağlantı oluştur
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = "Alan Raporu";

                // Bağlantıyı tıkla
                link.click();

                // Blob URL'yi serbest bırak
                URL.revokeObjectURL(blobUrl);
                fnc(response.data.data);
            })
        } catch (e) {

        }
    }

    const getCalculationOfPopulationServedRate = async (data, fnc) => {

        try {
            requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/Report/GetCalculationOfPopulationServedRate", data).then(response => {

                if (!response.success) {
                    if (fnc) {
                        fnc(response.message);
                    }
                    return;
                }
                const byteCharacters = atob(response.data.base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

     
                const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = "Hizmet verilen nufus oranı";

                link.click();
                URL.revokeObjectURL(blobUrl);
                fnc(response);
            })
        } catch (e) {

        }
    }

    const getPotantialAtnSampleFile = async (fnc) => {

        try {
            requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/Report/PotantialAtnSampleFile", {}).then(response => {

                if (!response.success) {
                    if (fnc) {
                        fnc(response.message);
                    }
                    return;
                }
                const byteCharacters = atob(response.data.base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                // Blob oluştur
                const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // Blob URL oluştur
                const blobUrl = URL.createObjectURL(blob);

                // Bağlantı oluştur
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = "Potansiyel_Esnaf_Noktası_Ornek_Dosya";

                // Bağlantıyı tıkla
                link.click();

                // Blob URL'yi serbest bırak
                URL.revokeObjectURL(blobUrl);

            })
        } catch (e) {

        }
    }

    const setDrawState = (data) => {

        dispatch(success(data));

        function success(data) { return { type: constant.SET_DRAWOPEN, payload: data }; }
    };
    return (
        <whereIsThisContext.Provider value={[state,
            {
                changeCoordinate,
                changeObjectType,
                getUseFeedBack,
                setSelectedFeatures,
                getSelectedFeatures,
                exportAdministrativeAreawithWkt,
                setAddressData,
                freeSpaceAreaReport,
                setIsLoading,
                reloadCustomerData,
                demographicAreaReport,
                getCalculationOfPopulationServedRate,
                getPotantialAtnSampleFile,
                reloadTreeData,
                setDrawState
            }]}>
            {props.children}
        </whereIsThisContext.Provider>
    )
};


